<template>
    <v-card color="primary">
    <v-card-title class="font-weight-bold">Network Details</v-card-title>
    <v-simple-table dense>
        <template v-slot:default>
        <tbody>
            <tr>
            <td>Name</td>
            <td>{{ networkDetails.name }}</td>
            </tr>
            <tr>
            <td>Network Inspector</td>
            <td>{{ displayTimestamp(networkDetails.networkSnapshot) }}</td>
            </tr>
            <tr>
            <td>Baseline Comparison</td>
            <td>{{ displayTimestamp(networkDetails.baselineSnapshot) }}</td>
            </tr>
        </tbody>
        </template>
    </v-simple-table>
    </v-card>
</template>


<script>
import * as d3 from "d3-time-format";

export default {
    props: {
      networkDetails: Object
    },
    computed: {
    },
    methods: {
      displayTimestamp(ele) {
        let format = d3.timeFormat("%B %d, %Y %H:%M:%S");
        if (ele != 'Current live network') {
          return format(ele);
        } else {
          return ele;
        }
      }
    },
    mounted: function() {
    }
}
</script>